import { Link } from "react-router-dom";
import { useEffect } from "react";
import "./Home.css";
import { greeting } from "../../profile";
import axios from "axios";

function Home() {
  useEffect(() => {
    axios.post("https://website-visitor-data.onrender.com").catch(err => {
      console.log("Visitor analytics service offline");
    });
  }, []);

  return (
    <div className="home-container fade-in">
      <div className="home-content">
        {/* Left Column: Info & Action Buttons */}
        <div className="hero-text-section">
          <div className="welcome-badge">
            <span className="badge-pulse"></span>
            {greeting.welcome}
          </div>
          <h1 className="hero-main-title">
            Namaste 🙏 <br />
            This is <span className="highlight-text">Atul</span>
          </h1>
          <p className="hero-subtitle">
            {greeting.subTitle.split("|").map((item, idx) => (
              <span key={idx} className="subtitle-pill">
                {item.trim()}
              </span>
            ))}
          </p>

          <div className="hero-actions">
            <Link to="/about" className="action-btn btn-primary">
              Know About Me
            </Link>
            <Link to="/contact" className="action-btn btn-secondary">
              Connect with Me
            </Link>
            <a
              href="https://drive.google.com/file/d/1iXTEuSktwvd6GdN_FuzARhlfj4VN4r1D/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="action-btn btn-outline"
            >
              Resume 📄
            </a>
          </div>
        </div>

        {/* Right Column: Visual Component */}
        <div className="hero-visual-section">
          <div className="image-glow-wrapper">
            <div className="glow-backdrop"></div>
            <img 
              src={greeting.home_gif} 
              alt="Programming illustration" 
              className="hero-image" 
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
